import { render } from "./AnneeAccordion.vue?vue&type=template&id=1586823d"
import script from "./AnneeAccordion.vue?vue&type=script&lang=js"
export * from "./AnneeAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__